import { render } from "./NossosClientes.vue?vue&type=template&id=063dd7d3&scoped=true&bindings={\"clientes\":\"data\",\"activeClient\":\"data\",\"handleSelect\":\"options\"}"
import script from "./NossosClientes.vue?vue&type=script&lang=js"
export * from "./NossosClientes.vue?vue&type=script&lang=js"

import "./NossosClientes.vue?vue&type=style&index=0&id=063dd7d3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-063dd7d3"

export default script